/**
 * Adapptio core library.
 *
 * @package core
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { ItemRegistry } from "@adapptio/lib-shared";
import { TGenericAuthProviderDefinition } from "../auth/IAuthProviderDefinition";

/**
 * Auth Provider Registry
 */
// TODO: remove all these registry type
export type IAuthProviderDefRegistry = ItemRegistry<TGenericAuthProviderDefinition>;

export class AuthProviderDefRegistry extends ItemRegistry<TGenericAuthProviderDefinition> {}
